// Crane Inks — non-destructive bullet enhancer for product descriptions.
// Handles two source patterns equally well:
//   (A) One <p> with several "• line" rows separated by <br>
//   (B) One <p> per bullet:  <p>• line</p>
// Adds .crane-bullet-line wrapper + .crane-bullet-marker for hanging indent.
// Safety: never overwrites markup unless visible text is preserved verbatim.

(function () {
  'use strict';

  var BULLET_RE = /^[•·◦‣\-–—]\s+/;
  var BULLET_STRIP_RE = /^(\s*)[•·◦‣\-–—]\s+/;

  function normalize(s) {
    return (s || '')
      .replace(/ /g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  // Pattern A: split <p> on <br> and wrap any bullet line found.
  function enhanceWithBr(p) {
    var originalHtml = p.innerHTML;
    var originalText = p.textContent;
    if (!/<br/i.test(originalHtml)) return false;
    if (!/[•·◦‣\-–—]/.test(originalText)) return false;

    var parts = originalHtml.split(/<br\s*\/?>/i);
    var transformed = false;
    var newHtml = parts.map(function (part) {
      var probe = document.createElement('div');
      probe.innerHTML = part;
      var t = probe.textContent.replace(/^\s+/, '');
      var m = t.match(BULLET_RE);
      if (!m) return part;
      var stripped = part.replace(BULLET_STRIP_RE, '$1');
      transformed = true;
      return '<span class="crane-bullet-line"><span class="crane-bullet-marker" aria-hidden="true">•</span><span class="crane-bullet-text">' + stripped + '</span></span>';
    }).join('');

    if (!transformed) return false;

    var probe = document.createElement('div');
    probe.innerHTML = newHtml;
    if (normalize(probe.textContent) !== normalize(originalText)) return false;

    p.innerHTML = newHtml;
    return true;
  }

  // Pattern B: whole <p> is a single bullet line.
  function enhanceWhole(p) {
    var text = p.textContent;
    var stripped = text.replace(/^\s+/, '');
    if (!BULLET_RE.test(stripped)) return false;
    // Walk past whitespace-only text nodes to find the first node with
    // actual content (the one carrying the leading bullet character).
    var walker = document.createTreeWalker(p, NodeFilter.SHOW_TEXT, null, false);
    var firstText = null;
    var n;
    while ((n = walker.nextNode())) {
      if (/\S/.test(n.nodeValue)) { firstText = n; break; }
    }
    if (!firstText) return false;
    firstText.nodeValue = firstText.nodeValue.replace(BULLET_STRIP_RE, '$1');
    var marker = document.createElement('span');
    marker.className = 'crane-bullet-marker';
    marker.setAttribute('aria-hidden', 'true');
    marker.textContent = '•';
    p.classList.add('crane-bullet-line');
    p.setAttribute('data-crane-bullet', '1');
    p.insertBefore(marker, p.firstChild);
    return true;
  }

  function enhance(p) {
    if (!p || p.dataset.craneEnhanced === '1') return;
    p.dataset.craneEnhanced = '1';
    if (enhanceWithBr(p)) return;
    enhanceWhole(p);
  }

  function init() {
    document.querySelectorAll('.product__description p, .product__description li').forEach(enhance);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
